import { useEffect } from 'react';

// eslint-disable-next-line react-hooks/exhaustive-deps
const useMountEffect = (callback) => useEffect(callback, []);

export default useMountEffect;
